import jwtDecode from 'jwt-decode';

import {
  BASE_URL,
  ENDPOINTS,
} from 'Constants/apiEndpoints';
import {
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
} from "Constants/settings";
import {
  ERROR_CATEGORIES,
  ERROR_CODES,
  ERROR_DESCRIPTION,
} from "Constants/nciConstants";


const defaultPostHeaders = [
  {
    name: 'Content-Type',
    value: 'application/json',
  },
];
const RestManager = {
  request: async (url, method = 'GET', headers = []) => {
      const res = await RestManager.checkAccessToken();
      if (res && res['error_code']) {
        return new Promise((resolve, reject) => {
          reject({error_code: res['error_code']});
        });

      } else if (res && res['error_category'] && res['error_category'] === ERROR_CODES.OTHER) {
        return new Promise((resolve, reject) => {
          reject({error_category: res['error_category']});
        });
      }

    const options = {
      method,
      headers: RestManager.getHeaders(headers),
      mode: 'cors',
      cache: 'default'
    };
    // const fUrl = BASE_URL+url;
    const fUrl = url.startsWith('/api') ? url : BASE_URL + url;
    // console.log('GET REQUEST URL: ', fUrl);
    const json = await fetch(fUrl, options)
      .then(response => {
        // if (response.status === 404) {}
        // console.log('GET response: ', response)
        // RestManager.checkAuth(response);
        return response.json()
      });

    return json;
  },

  requestWithoutQueryParams: async (url, method = 'POST', bodyData = {}, headers = []) => {
    if (!url.includes(ENDPOINTS.AUTH.VERIFY_NUMBER) && !url.includes(ENDPOINTS.AUTH.VERIFY_CODE)) {
      const res = await RestManager.checkAccessToken();
      if (res && res['error_code']) {
        return new Promise((resolve, reject) => {
          reject({error_code: res['error_code']});
        });
      } else if (res && res['error_category'] && res['error_category'] === ERROR_CODES.OTHER) {
        return new Promise((resolve, reject) => {
          reject({error_category: res['error_category']});
        });
      }
    }

    const body = JSON.stringify(bodyData);
    const options = {
      method,
      headers: RestManager.getHeaders([...defaultPostHeaders, ...headers]),
      mode: 'cors',
      cache: 'default',
      body
    };
    const finalUrl = url.startsWith('/api') ? url : BASE_URL + url;
    // const finalUrl = url;
    const json = await fetch(finalUrl, options)
      .then((response) => {
        // RestManager.checkAuth(response);
        if (method === 'DELETE' || response.status === 204) {
          return new Promise((resolve) => {
            resolve({ status: response.status })
          });

        }
        return response.json();
      });

    return json;
  },

  getHeaders(additionalHeaders) {
    let headers = new Headers();

    const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    headers.append('Authorization', `Bearer ${accessToken}`);

    additionalHeaders.forEach(item => {
      headers.append(item.name, item.value);
    });

    return headers;
  },

  refreshAccessToken: async (url, method = 'POST', bodyData = {}, headers = []) => {
    let heads = RestManager.getHeaders([...headers]);
    // let heads = RestManager.getHeaders([...defaultPostHeaders, ...headers]);

    const options = {
      method,
      headers: heads,
      // mode: 'cors',
      cache: 'default',
      body: JSON.stringify(bodyData),
    };

    let json;
    try {
      json = await fetch(url, options)
        .then(async (response) => {
          // console.log('REFRESH ACCESS TOKEN: ', response);
          return response.json();
        }).catch((err) => {
          console.log('ERROR REFRESH METHOD 2: ', err);
        });
    } catch (e) {
      console.log('ERROR REFRESH METHOD: ', e);
    }
    return json;
  },

  async checkAuth(response) {
    if (!response
      || (response.status
        && (response.status === 401 || response.status === 403 || response.status === 406))) {
      console.error('checkAuth RESPONS ERR:: ', response);
    }
  },

  async checkAccessToken(response) {
    const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    const decoded = jwtDecode(accessToken);

    const exp = decoded.exp * 1000;
    const now = new Date(); // seconds
    const nowTime = now.getTime();
    const isExpired = nowTime >= exp;

    if (isExpired) {
      const aToken = localStorage.getItem(ACCESS_TOKEN_KEY);
      const rToken = localStorage.getItem(REFRESH_TOKEN_KEY);
      const body = {
        access_token: aToken,
        refresh_token: rToken
      }
      const refreshTokenUrl = `${BASE_URL}${ENDPOINTS.AUTH.REFRESH_TOKEN}`;
      const response2 = await RestManager.refreshAccessToken(refreshTokenUrl, 'POST', body);
      // console.log('REFRESH ACCESS TOKEN response: ', response2);

      if (response2['error_code']
        && (response2['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED || response2['error_code'] === ERROR_CODES.EXPIRED_REFRESH_TOKEN)) {
        console.log('EXPIRED REFRESH TOKEN: ', response2);
        return new Promise((resolve, reject)=> {
          resolve(response2);
        });
      } else if (!response2
        || (response2.status && (response2.status === 400 || response2.status === 401 || response2.status === 406))) {
        console.log('EXPIRED REFRESH TOKEN 2 : ', response2);
        return new Promise((resolve, reject)=> {
          resolve(response2);
        });
      } else if (response2 && response2.access_token && response2.refresh_token) {
        // console.log('SET NEW TOKENS');
        localStorage.setItem(ACCESS_TOKEN_KEY, response2.access_token);
        localStorage.setItem(REFRESH_TOKEN_KEY, response2.refresh_token);
      } else if (response2['error_category'] && response2['error_category'] === ERROR_CODES.OTHER) {
        console.log('EXPIRED REFRESH TOKEN 3 : ', response2);
        return new Promise((resolve, reject)=> {
          resolve({'error_category': ERROR_CODES.OTHER});
        });
      } else {
        console.log('REFRESH TOKEN FAILED');
        return new Promise((resolve, reject)=> {
          resolve(response2);
        });
      }
    } else if (!isExpired && response && response.status === 401) {
      console.log('INVALID ACCESS TOKEN PARAMETER: ', response);
    }
  },
};

export default RestManager;
